export default "__VITE_ASSET__Bg0RYHbU__"